//@flow
import React, { Component } from "react";
import "./list-item.scss";
import Price from "../pricing";
import type { ProductType } from "../types/product.js";
import type { PricingType } from "../types/pricing.js";
import type { ProductPurchasability } from "../types/publicpurchasable";
import AddToCart from "../add-to-cart";
import Quanity from "../quantity";
import ProductDetails from "../product-details";
import ListItemImage from "../list-item-image";
import ListItemIdentity from "../list-item-identity";
import RemoveWishlistButton from "../remove-wishlist-button";

type Props = {
  product: ProductType,
  pricing: ?PricingType,
  purchasability: ?ProductPurchasability,
  isPostCodeAvailable: boolean,
  isLoadingPurchasability: boolean,
  isLoggedInUser: boolean,
  onRemove: (productCode: number) => void,
  onShowPostcodeClicked: () => void,
  onQuantityChanged: (productCode: number, newQuantity: number) => void
};

class ListItem extends Component<Props> {
  onQuantityAdd = () => {
    this.props.onQuantityChanged(
      this.props.product.productCode,
      this.props.product.quantity + 1
    );
  };

  onQuantityDeduct = () => {
    const canDecrease = this.props.product.quantity > 1;
    this.props.onQuantityChanged(
      this.props.product.productCode,
      canDecrease
        ? this.props.product.quantity - 1
        : this.props.product.quantity
    );
  };

  render() {
    let isPricingAvailable: boolean =
      this.props.pricing && this.props.pricing.gstInclusivePricing
        ? true
        : false;
    const { onRemove, onShowPostcodeClicked } = this.props;

    return (
      <div className="wishlist-tile__inner">
        <div className="wishlist-tile__section-content">
          <ListItemImage product={this.props.product} />
          <div className="wishlist-tile__main-content">
            <ListItemIdentity product={this.props.product} />
            <Quanity
              quantity={this.props.product.quantity}
              onAddQuantity={this.onQuantityAdd}
              onDeductQuantity={this.onQuantityDeduct}
            />
            <Price
              isPostCodeAvailable={this.props.isPostCodeAvailable}
              onShowPostcodeClicked={onShowPostcodeClicked}
              price={
                this.props.pricing && this.props.pricing.gstInclusivePricing
              }
            />
          </div>
          <AddToCart
            isLoadingPurchasability={this.props.isLoadingPurchasability}
            purchasability={this.props.purchasability}
            isPricingAvailable={isPricingAvailable}
            product={this.props.product}
            isPostCodeAvailable={this.props.isPostCodeAvailable}
            isLoggedInUser={this.props.isLoggedInUser}
          />
        </div>

        <ProductDetails specifications={this.props.product.specifications} />

        <RemoveWishlistButton
          productCode={this.props.product.productCode}
          onRemove={onRemove}
        />
      </div>
    );
  }
}

export default ListItem;
